import { RenderUtils } from '@wix/photography-client-lib';
export var utils = new RenderUtils();
//# sourceMappingURL=utils.js.map